import React from "react";
const getDirectionStyle = (direction) => {
  if (!direction || direction === "bottom")
    return {};
  if (direction === "top")
    return { transform: "rotate(-180deg)" };
  if (direction === "left")
    return { transform: "rotate(90deg)" };
  return { transform: "rotate(-90deg)" };
};
const IconChevron = ({ direction, style, ...props }) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 7",
  width: "12",
  height: "7",
  style: {
    ...style,
    ...getDirectionStyle(direction)
  },
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M9.96994 0.969375C10.2624 0.676875 10.7379 0.676875 11.0304 0.969375C11.3229 1.26187 11.3229 1.73737 11.0304 2.02987L6.53044 6.52988C6.23794 6.82238 5.76244 6.82238 5.46994 6.52988L0.969938 2.02987C0.676687 1.73737 0.676687 1.26187 0.969938 0.969375C1.26319 0.676875 1.73794 0.676875 2.03044 0.969375L6.00019 4.93913L9.96994 0.969375Z",
  fill: "currentColor"
}));
var IconChevron_default = IconChevron;
export {
  IconChevron_default as default
};
